import { render, staticRenderFns } from "./saveButton.vue?vue&type=template&id=2c8cf3bc&scoped=true&"
import script from "./saveButton.vue?vue&type=script&lang=js&"
export * from "./saveButton.vue?vue&type=script&lang=js&"
import style0 from "./saveButton.vue?vue&type=style&index=0&id=2c8cf3bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8cf3bc",
  null
  
)

export default component.exports